// src/utils/userUtils.js

const USERS_KEY = "users";

export function getAllUsers() {
  return JSON.parse(localStorage.getItem(USERS_KEY)) || [];
}

export function updateUser(email, newData) {
  const users = getAllUsers();
  const idx = users.findIndex((u) => u.email === email);
  if (idx === -1) return null;
  users[idx] = { ...users[idx], ...newData };
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  return users[idx];
}

export function deleteUser(email) {
  let users = getAllUsers();
  users = users.filter((u) => u.email !== email);
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
  return users;
}
